// import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/storage'
import { genRandomStr } from '@/utils/random.js'

export default class FirebaseService {
    constructor(siteFolder) {
        if (!siteFolder) throw '系統錯誤: service siteFolder not found'
        this.siteFolder = siteFolder
        var firebaseConfig = {
            apiKey: 'AIzaSyDzM3w0WC1OVIFSpogV45Mk4eDBAQVcdHs',
            authDomain: 'wanwaninfo.firebaseapp.com',
            databaseURL: 'https://wanwaninfo.firebaseio.com',
            projectId: 'wanwaninfo',
            storageBucket: 'wanwaninfo-public-tw',
            messagingSenderId: '253052645293',
            appId: '1:253052645293:web:a565aa7f8b21f3a2'
        }
        firebase.initializeApp(firebaseConfig)

        this.idx = 0
    }

    upload(blob, prefix, fileExtension = 'jpg') {
        var storageRef = firebase.storage().ref()

        var name = genRandomStr(10) + (new Date().getTime()) + '' + (++this.idx)
        var ref = storageRef.child(this.siteFolder + '/' + (prefix || '') + name + '.' + fileExtension)

        return ref.put(blob).then(snapshot => {
            let url = this.getURL(snapshot)
            return url
        })
    }

    getURL(snapshot) {
        var url = snapshot.ref.location.fullServerUrl()
        return 'https://firebasestorage.googleapis.com/v0' + url + '?alt=media'
    }
}
